import { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { AddCircle, CloseSquare } from "iconsax-react";
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Alert,
    IconButton,
    Autocomplete,
    TextField,
    Collapse
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '../../icons/save-icon.png'
import { singleSectionCategories } from "../../constants/general";
import styles from "../my-data.module.scss";

const AddSectionModal = observer(({
    category,
    uiStore,
    sectionName,
    sectionType,
    updateData,
    type,
    handleEditModeCollapse,
    sections,
}) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('');
    const [customName, setCustomName] = useState('');
    const [options, setOptions] = useState([]);
    const [error, setError] = useState('');

    const save = async () => {
        if (!customName && !value) {
            setError('Section name is required');
            return;
        }
        setLoading(true);
        const data = await uiStore.addSection(category, customName ? customName : value, value ? value : 'Custom');
        updateData(data);
        setLoading(false);
        setShow(false);
        handleEditModeCollapse(customName ? customName : value, true);
    }

    const saveSection = async () => {
        setLoading(true);
        const data = await uiStore.addSection(category, sectionName, sectionType);
        updateData(data);
        setLoading(false);
        setShow(false);
        handleEditModeCollapse(type, true);
    }

    const handleChange = (e, value) => {
        setValue(value);
    };

    const handleCustomNameChange = (e) => {
        setCustomName(e.target.value);
    };

    const dontRepeatSections = [
        // 'Main',
        'Name',
        'Dates',
        'Relationships'
    ];

    async function fetchData(showModal = false) {
        setValue('');
        const currentSections = await sections?.map(i => i.name);
        const data = await uiStore.getUserSectionsOptions(category);
        let op = data?.map(i => i.name);
        dontRepeatSections.forEach((section, index) => {
            if (currentSections?.includes(section)) {
                // op.pop();
                op = op.filter(s => s !== section);
            }

        })
        setOptions(op);
        setShow(showModal);
    }

    useEffect(() => {
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category, uiStore, sections]);

    useEffect(() => {
        setCustomName('');
        
    }, [show]);

    const openModal = () => {
        fetchData(true);
    }

    return (
        <Box sx={{ textAlign: 'center' }}>
            {!!options?.length &&
                <>
                    {
                        sectionName ?
                            <LoadingButton
                                sx={{ borderRadius: '100px', mr: 1 }}
                                loading={!!loading}
                                onClick={saveSection}
                                variant="contained"
                                color="lightblue"
                                className={`${styles.mydataEditBtn} ${styles.hideInMobile}`}
                                title={"New " + (singleSectionCategories.includes(category) ? category : sectionName)}
                            >
                                <AddCircle
                                    size="24"
                                    variant="Bulk"
                                />
                                <Box className={styles.hideText} sx={{ ml: 1 }}>New</Box>
                            </LoadingButton>
                            :
                            <LoadingButton
                                startIcon={
                                    <AddCircle
                                        size="24"
                                        variant="Bulk"
                                    />
                                }
                                variant="contained"
                                color="lightblue"
                                loading={!!loading}
                                onClick={() => openModal()}
                                className={`${styles.mydataEditBtn}`}

                                title={"Add " + category + " Section"}
                            >
                                Add {category} Section
                            </LoadingButton>
                    }
                </>
            }

            <Dialog fullWidth open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            >
                <DialogTitle>
                    Add section
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {error &&
                        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                    }
                    {!(options?.length === 1 && options[0] === 'Custom') &&
                        <>
                            Select a section to add
                            <Autocomplete
                                options={options}
                                renderInput={(params) => <TextField {...params} label={'Section name'} />}
                                sx={{ margin: '20px 0' }}
                                value={value}
                                disabled={loading}
                                onChange={handleChange}
                                required
                            />
                        </>
                    }

                    <Collapse in={(options?.length === 1 && options[0] === 'Custom') || value === 'Custom'}>
                        Create a new section with custom name
                        <TextField
                            fullWidth
                            sx={{ margin: '20px 0' }}
                            value={customName}
                            disabled={loading}
                            onChange={handleCustomNameChange}
                            label='Custom Name'
                            required
                        />
                    </Collapse>

                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={save} variant="contained" color="secondary"
                        endIcon={
                            <img src={SaveIcon}
                                alt='Save icon'
                                width={24}
                            />
                        }
                        disabled={(!value && !customName)}
                    >
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box>
    );
});

export default AddSectionModal;
